import classNames from 'classnames/bind';
import styles from './ProjectDetailPage.module.scss';
import MarkdownViewer from '~/Layouts/components/MarkdownViewer';
import { useContext, useEffect, useState } from 'react';
import { getData, postData } from '~/helper/apiService';
import { useParams } from 'react-router-dom';
import ProjectItem from '~/component/ProjectItem';
import { ModalOverLayContext } from '~/component/Context/ModalOverLayProvider';
import ConfirmModal from '~/component/ConfirmModal';
import useMeta from '~/hooks/useMeta';

const cx = classNames.bind(styles);

function ProjectDetailPage() {
  const [project, setProject] = useState({});
  const { id } = useParams();
  const { setModalComponentContent } = useContext(ModalOverLayContext);

  const loadData = async () => {
    const data = await getData(`/projects/read/${id}`);
    setProject(data[0]);
  };

  const handleRemoveProject = async () => {
    const formData = new FormData();
    formData.append('id', project.id);
    const res = await postData('/projects/delete', formData);
    if (res.status === 'success') {
      loadData();
    }
  };

  const handleClickDelete = ()=>{
    setModalComponentContent(<ConfirmModal
        title="Xác nhận xóa project"
        handleConfirm={handleRemoveProject}
        handleCancel={setModalComponentContent(null)}
      />)
  }

  useEffect(() => {
    loadData();
  }, []);

  useMeta({
    title: `${project?.name} | Ngô Gia Quyến`,
    description: project?.descriptions,
    keywords: 'GYMZ, thể hình, sức khỏe, luyện tập, gym, huấn luyện viên, dinh dưỡng, Node.js, Express.js, MySQL',
    author: 'Ngô Gia Quyến',
    url: `https://ngogiaquyen.id.vn//project-detail/${id}`,
  });

  if (!project) {
    return <div>Không tìm thấy project.</div>;
  }

  return (
    <div className={cx('wrapper')}>
      <div className={cx('item-wrap')}>
        <ProjectItem data={project} handleRemove={handleClickDelete} />
      </div>
      <div className={cx('preview')}>
        <MarkdownViewer content={project.content} />
      </div>
    </div>
  );
}

export default ProjectDetailPage;
